import {Outlet} from 'react-router-dom';
import styles from './index.module.less';

/**
 * 桌面端最小宽度布局
 * 用于需要 1200px 最小适配宽度的页面。
 */
const DesktopLayout: React.FC = () => {
    return (
        <div className={styles.desktopLayout}>
            <Outlet />
        </div>
    );
};

export default DesktopLayout;
